import request from '@/infra/request';

/**
 * 获取登录用户信息
 */
export function getUserInfo() {
    return request.get('/api/getLoginUser');
}

/**
 * 用户登录
 */
export function login(params) {
    const { username, password } = params;

    return request.post('/api/login', { account: username, password, tenantId: 0 });
}

/**
 * 退出登录
 */
export function logout() {
    return request.get('/api/logout');
}

//============================组织机构================================
// 组织机构树结构
export function getOrgTree(params) {
    return request.get('/api/sysOrg/tree', { params });
}
// 组织机构列表
export function getOrgList(params) {
    return request.get('/api/sysOrg/list', { params });
}
// 新建组织机构
export function addOrg(params) {
    return request.post('/api/sysOrg/add', params);
}
// 编辑组织机构
export function updateOrg(params) {
    return request.post('/api/sysOrg/edit', params);
}
// 删除组织机构
export function deleteOrg(params) {
    return request.post('/api/sysOrg/delete', params);
}

//============================职位================================

// 职位列表
export function getPositionList(params) {
    return request.get('/api/sysPos/list', { params });
}
// 新建职位
export function addPosition(params) {
    return request.post('/api/sysPos/add', params);
}
// 编辑职位
export function updatePosition(params) {
    return request.post('/api/sysPos/edit', params);
}
// 删除职位
export function deletePosition(params) {
    return request.post('/api/sysPos/delete', params);
}
/**
 * 交易通道列表
 */
export function tradeChannelList(params) {
    return request.get('/api/T_Trading_Channel/list', { params });
}

/**
 * 新增交易通道
 * {
 *   "broker_id": "string",
 *   "broker_name": "string",
 *   "primary_secondary": 1,
 *   "ip_address": "string",
 *   "ip_port": "string"
 * }
 */
export function addTradeChannel(params) {
    return request.post('/api/T_Trading_Channel/add', params);
}

export function editTradeChannel(params) {
    return request.post('/api/T_Trading_Channel/edit', params);
}

export function deleteTradeChannel(id) {
    return request.post('/api/T_Trading_Channel/delete', { id });
}

export function tradeChannelDetail(id) {
    return request.get('/api/T_Trading_Channel/delete', { params: { id } });
}

//============================物料清单================================
/**
 * 查询物料清单列表
 */
export function getBomList(params) {
    return request.get('/api/t_commodity_bom/list', { params });
}
/**
 * 添加物料
 */
export function addBom(params) {
    return request.post('/api/t_commodity_bom/add', params);
}

/**
 * 编辑物料
 */
export function updateBom(params) {
    return request.post('/api/t_commodity_bom/edit', params);
}
/**
 * 删除物料
 */
export function deleteBom(params) {
    return request.post('/api/t_commodity_bom/delete', params);
}

//============================套期品种================================
/**
 * 查询套期品种列表
 */
export function getCommodityList(params) {
    console.log('params>>>>>>>', params);
    return request.get('/api/T_Commodity/list', { params });
}

/**
 * 添加套期品种
 */
export function addCommodity(params) {
    return request.post('/api/T_Commodity/add', params);
}

/**
 * 编辑套期品种
 */
export function updateCommodity(params) {
    return request.post('/api/T_Commodity/edit', params);
}
/**
 * 删除套期品种
 */
export function deleteCommodity(params) {
    return request.post('/api/T_Commodity/delete', params);
}

//============================套期关系================================
/**
 * 查询套期关系列表
 */
export function getHedgingRelationshipList(params) {
    return request.get('/api/T_Hedging_Relationship/list', { params });
}

/**
 * 添加套期关系
 */
export function addHedgingRelationship(params) {
    return request.post('/api/T_Hedging_Relationship/add', params);
}

/**
 * 编辑套期关系
 */
export function updateHedgingRelationship(params) {
    return request.post('/api/T_Hedging_Relationship/edit', params);
}
/**
 * 删除套期关系
 */
export function deleteHedgingRelationship(params) {
    return request.post('/api/T_Hedging_Relationship/delete', params);
}
//============================金融衍生工具================================
export function getInstrumentList(params) {
    return request.get('/api/T_Instrument/list', { params });
}
/**
 * 添加套期关系
 */
export function addInstrument(params) {
    return request.post('/api/T_Instrument/add', params);
}

/**
 * 编辑套期关系
 */
export function updateInstrument(params) {
    return request.post('/api/T_Instrument/edit', params);
}
/**
 * 删除套期关系
 */
export function deleteInstrument(params) {
    return request.post('/api/T_Instrument/delete', params);
}

//============================资金账户================================

export function getTradeAccountList(params) {
    return request.get('/api/T_Trading_Account/list', { params });
}

/**
 * 添加资金账户
 */
export function addTradeAccount(params) {
    return request.post('/api/T_Trading_Account/add', params);
}

/**
 * 编辑资金账户
 */
export function updateTradeAccount(params) {
    return request.post('/api/T_Trading_Account/edit', params);
}
/**
 * 删除资金账户
 */
export function deleteTradeAccount(params) {
    return request.post('/api/T_Trading_Account/delete', params);
}
//============================套保方案================================
export function getHedgingStrategyList(params) {
    return request.get('/api/T_Hedging_Strategy/hedgingstrategylist', {
        params,
    });
}
/**
 * 添加套保方案
 */
export function addHedgingStrategy(params) {
    return request.post('/api/T_Hedging_Strategy/add', params);
}

/**
 * 编辑套保方案
 */
export function updateHedgingStrategy(params) {
    return request.post('/api/T_Hedging_Strategy/edit', params);
}
/**
 * 删除套保方案
 */
export function deleteHedgingStrategy(params) {
    return request.post('/api/T_Hedging_Strategy/delete', params);
}
/**
 * 获取套保方案配置服务
 */
export function getHedgingStrategyConfigData(params) {
    return request.get('/api/T_Hedging_Strategy/hedgingstrategyCheckList', {
        params,
    });
}

//===========================套期关系-资金账户权限配置================================
/**
 * 查询套保业务已勾选机构
 */
export function getHedgingbusinessCheckedOrgs(params) {
    return request.get(
        '/api/T_Org_Relationship_Accounting/HedgingOrgCheckbox',
        {
            params,
        },
    );
}
/**
 * 查询套保业务组织关系与套期关系的关联关系
 */
export function getHedgingOrgRealtedRelationship(params) {
    return request.get(
        '/api/T_Org_Relationship_Accounting//HedgingRelationshipCheckbox',
        { params },
    );
}
/**
 * 查询资金账户号关系与套期关系的关联关系
 */
export function getHedgingAccountRealtedCommodity(params) {
    let data = params;
    return request.get(
        '/api/T_Org_Relationship_Accounting/HedgingRelationshipAccountingCheckbox',
        { params },
    );
}
/**
 * 查询投资业务已勾选机构
 */
export function getInvestbusinessCheckedOrgs(params) {
    return request.get('/api/T_Org_Relationship_Accounting//OrgCheckbox', {
        params,
    });
}

/**
 * 查询资金账户号与投资业务组织机构的关联关系
 */
export function getInvestAccountRealtedInvestOrgs(params) {
    let data = params;
    return request.get(
        '/api/T_Org_Relationship_Accounting/AccountingCheckbox',
        {
            params,
        },
    );
}
/**
 * 保存套保业务机构、套期关系、资金账户的关联关系
 */
export function saveOrgRelationshipAccount(params) {
    return request.post(
        '/api/T_Org_Shipment_Accounting/edithedgingaccounting',
        params,
    );
}

/**
 * 保存投资业务机构、资金账户的关联关系
 */
export function saveOrgInvestAccount(params) {
    let data = params;
    return request.get('/api/T_Org_Shipment_Accounting/editaccounting', {
        params,
    });
}
